'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseControllerBackedDirective=require('../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const FatigueMeterType=require('../../../dist-es6/shared/domain/fatigueMeterType');let

IfFmTypeDirective=function(_BaseControllerBacked){_inherits(IfFmTypeDirective,_BaseControllerBacked);function IfFmTypeDirective(){_classCallCheck(this,IfFmTypeDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}IfFmTypeDirective.prototype.












factory=function factory(){
let directive=_BaseControllerBacked.prototype.factory.call(this);
directive.transclude=!0;
return directive;
};_createClass(IfFmTypeDirective,[{key:'restrict',get:function(){return'A'}},{key:'template',get:function(){return'<ng-transclude ng-if="::controller.isVisible" />'}},{key:'controller',get:function(){return IfFmTypeDirectiveController}}]);return IfFmTypeDirective}(BaseControllerBackedDirective);let


IfFmTypeDirectiveController=function(){_createClass(IfFmTypeDirectiveController,null,[{key:'$inject',get:function()
{
return['$attrs','userService'];
}}]);

function IfFmTypeDirectiveController($attrs,userService){_classCallCheck(this,IfFmTypeDirectiveController);
const attrValue=$attrs.pulsarIfFmType;

const invertMatch=attrValue.startsWith('!');

const desiredType=FatigueMeterType[invertMatch?attrValue.slice(1):attrValue];
if(!_.exists(desiredType)){
throw new Error(`Invalid FatigueMeterType, got: "${attrValue}"`);
}

const isMatch=userService.currentUser.fatigueMeterType===desiredType;

this.isVisible=invertMatch?!isMatch:isMatch;
}return IfFmTypeDirectiveController}();


module.exports=IfFmTypeDirective;
//# sourceMappingURL=ifFmTypeDirective.js.map
